module.exports = __webpack_public_path__ + "img/logo.dc6f4143.svg";